import {useEffect} from 'react';

import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useCalculateFromWithoutVatQuery, useCalculateFromWithVatQuery} from '@dms/api/core';
import {VatRateType} from '@dms/api/shared';

import {Nullish} from 'shared/web';

interface CalculatePriceProps {
  amount: string;
  countryCode?: string;
  vatCode: VatRateType | Nullish;
  type?: string | Nullish;
  onChange: (res: {withVat?: string} | {withoutVat?: string}) => void;
}

export function useCalculatePrice(props: CalculatePriceProps) {
  const areFetchingPropsValid = isNotNilOrEmpty(props.amount) && isNotNilOrEmpty(props.vatCode);

  const {data: fromWithVatData} = useCalculateFromWithVatQuery(
    {
      amount: props.amount,
      vatRateType: props.vatCode!,
      countryCode: props.countryCode ?? '',
    },
    {
      skip: isNil(props.vatCode) || props.type !== 'withVat' || !areFetchingPropsValid,
    }
  );

  const {data: fromWithoutVatData} = useCalculateFromWithoutVatQuery(
    {
      amount: props.amount,
      vatRateType: props.vatCode!,
      countryCode: props.countryCode ?? '',
    },
    {
      skip: isNil(props.vatCode) || props.type !== 'withoutVat' || !areFetchingPropsValid,
    }
  );

  useEffect(() => {
    if (!fromWithVatData) {
      return;
    }

    props.onChange({withoutVat: fromWithVatData.withoutVat});
  }, [fromWithVatData, props.onChange]);

  useEffect(() => {
    if (!fromWithoutVatData) {
      return;
    }

    props.onChange({withVat: fromWithoutVatData.withVat});
  }, [fromWithoutVatData, props.onChange]);
}
